import React from 'react';
import ProductCard from './productCard';
import { connect } from 'react-redux';
import ListAnimation from '../utils/animations/list';

const mapStateToProps = (state) => {
	const { productList } = state.rootReducer.buyCourse;
	const { isInternational } = state.rootReducer.loginDetails;
	return {
		productList,
		isInternational,
	};
};

const ProductsList = ({ showonly, productList, isInternational }) => (
	<div className="">
		<h3 className="section-body-title">Products list</h3>

		<ListAnimation className="buy-products-row">
			{typeof productList !== 'undefined'
				? Object.keys(productList).map((key) => {
					console.log('productList[key] ', productList[key])
					return key < 4 ? null : (
						(showonly && productList[key].product_category === showonly) ? (
							<ProductCard
								key={productList[key].product_id}
								isInternational={isInternational}
								{...productList[key]}
							/>
						) : (showonly === '' || typeof showonly === 'undefined') ? (
							<ProductCard
								key={productList[key].product_id}
								isInternational={isInternational}
								{...productList[key]}
							/>
						) : false
						// <ProductCard
						// 	key={productList[key].product_id}
						// 	isInternational={isInternational}
						// 	{...productList[key]}
						// />
					);
				})
				: null}
		</ListAnimation>
	</div>
);

export default connect(mapStateToProps)(ProductsList);
